import { numberToIndianWords } from "../lib/inrWords";

/**
 * Renders the amount-in-words hint used below every ₹ input in the app — helps the user
 * catch missing/extra zeros while typing. Renders nothing when the input is empty or 0.
 */
export function CurrencyHint({ value, className = "" }) {
  if (value === "" || value == null) return null;
  const numeric = Number(value);
  if (!Number.isFinite(numeric) || numeric === 0) return null;
  const words = numberToIndianWords(numeric);
  if (!words) return null;
  return (
    <p
      data-testid="currency-hint"
      className={`mt-1 text-xs italic text-gold/80 ${className}`}
      aria-live="polite"
    >
      {words}
    </p>
  );
}

export default CurrencyHint;
